import ace from 'ace-builds'

ace.define(
  'ace/mode/sf_liquid_highlight_rules',
  [],
  function (require, exports, _module) {
    'use strict'

    const oop = require('ace/lib/oop')
    const TextHighlightRules =
      require('ace/mode/text_highlight_rules').TextHighlightRules
    const HtmlHighlightRules =
      require('ace/mode/html_highlight_rules').HtmlHighlightRules

    const SfLiquidHighlightRules = function () {
      HtmlHighlightRules.call(this)

      const tags = [
        'addnewinputs',
        'add_new_row_button',
        'adjustmentbutton',
        'adjustmenttransaction',
        'break',
        'capture',
        'changeorientation',
        'comment',
        'continue',
        'currencyconfiguration',
        'cycle',
        'decrement',
        'echo',
        'for',
        'fori',
        'fix_indent',
        'hideunlessi',
        'ic',
        'if',
        'ifchanged',
        'ifi',
        'include',
        'increment',
        'input',
        'inputcomment',
        'input_validation',
        'linkto',
        'liquid',
        'locale',
        'newline',
        'newpage',
        'nic',
        'noinputcomment',
        'pop',
        'push',
        'radioinput',
        'raw',
        'render',
        'result',
        'rollforward',
        'signmarker',
        'stripnewlines',
        't',
        't=',
        'tablerow',
        'unexplained',
        'unless',
        'unreconciled',
        '$0',
        '$1',
        '$2',
        '$3',
        '$4',
        '$5',
        '$6',
        '$7',
        '$8',
        '$9',
        '$10',
        '$11',
        '$12',
        '$13',
        '$14',
        '$15',
        '$16',
        '$17',
        '$18',
        '$19',
        '$20',
        '$21',
        '$22',
        '$23',
        '$24',
        '$25',
        '$26',
        '$27',
        '$28',
        '$29',
        '$30',
        '$31',
        '$32',
        '$33',
        '$34',
        '$35',
        '$36',
        '$37',
        '$38',
        '$39',
        '$40',
      ]

      const blockTags = [
        'addnewinputs',
        'adjustmentbutton',
        'capture',
        'case',
        'comment',
        'currencyconfiguration',
        'fix_indent',
        'for',
        'fori',
        'hideunlessi',
        'ic',
        'if',
        'ifchanged',
        'ifi',
        'inputcomment',
        'linkto',
        'locale',
        'nic',
        'noinputcomment',
        'radiogroup',
        'raw',
        'signmarker',
        'stripnewlines',
        'tablerow',
        'unless',
      ]

      const endTags = blockTags.map(function (tag) {
        return 'end' + tag
      })

      const filters = [
        'abs',
        'active_as_director_on',
        'active_as_role_on',
        'add_rounding_difference_to_account_number',
        'advance_day',
        'advance_days',
        'advance_hour',
        'advance_hours',
        'advance_minute',
        'advance_minutes',
        'advance_month',
        'advance_months',
        'advance_second',
        'advance_seconds',
        'advance_week',
        'advance_weeks',
        'advance_year',
        'advance_years',
        'analytical_code',
        'append',
        'assets',
        'at_least',
        'at_most',
        'capitalize',
        'ceil',
        'compact',
        'concat',
        'currency',
        'currency_dc',
        'date',
        'default',
        'divided_by',
        'downcase',
        'escape',
        'escape_once',
        'filter',
        'first',
        'floor',
        'group_by',
        'indent',
        'index_by',
        'integer',
        'join',
        'label',
        'last',
        'liabilities',
        'lines',
        'localized_date',
        'lstrip',
        'map',
        'minus',
        'modulo',
        'multiline_table',
        'n_currency',
        'newline_to_br',
        'original_date',
        'p_and_l',
        'percentage',
        'plus',
        'prepend',
        'range',
        'remove',
        'remove_first',
        'replace',
        'replace_first',
        'retract_day',
        'retract_days',
        'retract_hour',
        'retract_hours',
        'retract_minute',
        'retract_minutes',
        'retract_month',
        'retract_months',
        'retract_second',
        'retract_seconds',
        'retract_week',
        'retract_weeks',
        'retract_year',
        'retract_years',
        'revenues',
        'reverse',
        'round',
        'rstrip',
        'size',
        'slice',
        'sort',
        'sort_natural',
        'split',
        'starred',
        'strip',
        'strip_html',
        'strip_newlines',
        'sum',
        'times',
        'truncate',
        'truncatewords',
        'uniq',
        'upcase',
        'url_decode',
        'url_encode',
        'value',
        'where',
        'localized',
        'validation',
      ]

      // Not quite tags, not quite filters
      const miscKeywords = [
        'ABS',
        'INT',
        'IRR',
        'MAX',
        'MIN',
        'RATE',
        'placeholder',
        'and',
        'as',
        'in',
        'else',
        'elsif',
        'or',
        'reversed',
        'when',
        'import_title',
        'show_label',
        'assign_option',
        'assign_errors',
      ]

      const keywords = tags.concat(endTags).concat(miscKeywords)

      const keywordMapper = this.createKeywordMapper(
        {
          keyword: keywords.join('|'),
          'keyword.block': blockTags.join('|'),
          'support.function': filters.join('|'),
          'keyword.definition': 'assign',
        },
        'identifier'
      )

      // add liquid start tags to the HTML start tags
      for (const rule in this.$rules) {
        this.$rules[rule].unshift(
          {
            token: 'variable',
            regex: '{%',
            push: 'liquid-start',
          },
          {
            token: 'variable',
            regex: '{{',
            push: 'liquid-start',
          }
        )
      }

      this.$rules['sf-comment'] = [
        {
          token: 'comment',
          regex: /\{% *endcomment *%\}/,
          next: 'pop',
        },
        {
          defaultToken: 'comment',
        },
      ]

      this.$rules['start'].unshift({
        token: 'comment',
        regex: /\{% *comment *%\}/,
        next: 'sf-comment',
      })

      this.addRules({
        'liquid-start': [
          {
            token: 'variable',
            regex: '}}',
            next: 'pop',
          },
          {
            token: 'variable',
            regex: '%}',
            next: 'pop',
          },
          {
            token: 'string', // single line
            regex: '["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]',
          },
          {
            token: 'string', // single line
            regex: "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']",
          },
          {
            token: 'constant.numeric', // hex
            regex: '0[xX][0-9a-fA-F]+\\b',
          },
          {
            token: 'constant.numeric', // float
            regex: '[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b',
          },
          {
            token: 'constant.language.boolean',
            regex: '(?:true|false)\\b',
          },
          {
            token: keywordMapper,
            regex: '[a-zA-Z_$][a-zA-Z0-9_$]*\\b',
          },
          {
            token: 'keyword.operator',
            regex: '/|\\*|\\-|\\+|=|!=|\\?\\:',
          },
          {
            token: 'paren.lparen',
            regex: /[[({]/,
          },
          {
            token: 'paren.rparen',
            regex: /[\])}]/,
          },
          {
            token: 'text',
            regex: '\\s+',
          },
        ],
      })

      this.normalizeRules()
    }
    oop.inherits(SfLiquidHighlightRules, TextHighlightRules)

    exports.SfLiquidHighlightRules = SfLiquidHighlightRules
  }
)
